import {
  getNotificationsForMembershipNumber,
  deleteNotificationBySecurityId
} from "../../services/notifications/NotificationsService";
import moment from "moment";

export const SET_NOTIFICATIONS = "setNotifications";
export const REMOVE_NOTIFICATION = "removeNotification";
export const RESET_NOTIFICATIONS = "resetNotifications";

export const setNotifications = selectedPolicy => {
  return async dispatch => {
    let response = await getNotificationsForMembershipNumber(
      selectedPolicy.MembershipNumber
    );

    const sortedNotifications =
      response.data &&
      response.data.sort(
        (a, b) => new moment(b.CreatedDate) - new moment(a.CreatedDate)
      );

    dispatch({
      type: SET_NOTIFICATIONS,
      payload: {
        membershipNumber: selectedPolicy.MembershipNumber,
        notifications: sortedNotifications,
        lastRequestedTime: Date.now()
      }
    });
  };
};

export const removeNotificationBySecurityId = securityId => {
  return async dispatch => {
    await deleteNotificationBySecurityId(securityId);
    dispatch({
      type: REMOVE_NOTIFICATION,
      payload: securityId
    });
  };
};

export const resetNotifications = () => ({
  type: RESET_NOTIFICATIONS
});
